import { IconPropsType } from '..';

export const CMSIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.39994 5.43175V4.00039H4.49994V5.43175C4.2407 5.52701 4.01693 5.69954 3.85887 5.92602C3.7008 6.1525 3.61604 6.42204 3.61604 6.69823C3.61604 6.97442 3.7008 7.24396 3.85887 7.47044C4.01693 7.69693 4.2407 7.86945 4.49994 7.96471V13.0047H5.39994V7.96903C5.66063 7.87461 5.88591 7.70218 6.04512 7.47518C6.20433 7.24819 6.28975 6.97765 6.28975 6.70039C6.28975 6.42313 6.20433 6.15259 6.04512 5.9256C5.88591 5.6986 5.66063 5.52617 5.39994 5.43175Z"
      fill="#6D7483"
    />
    <path
      d="M9.44997 9.03609V3.99609H8.54998V9.03177C8.29074 9.12704 8.06697 9.29956 7.90891 9.52604C7.75084 9.75253 7.66609 10.0221 7.66609 10.2983C7.66609 10.5744 7.75084 10.844 7.90891 11.0705C8.06697 11.2969 8.29074 11.4695 8.54998 11.5647V13.0047H9.44997V11.5691C9.70921 11.4738 9.93298 11.3013 10.091 11.0748C10.2491 10.8483 10.3339 10.5788 10.3339 10.3026C10.3339 10.0264 10.2491 9.75685 10.091 9.53036C9.93298 9.30388 9.70921 9.13136 9.44997 9.03609Z"
      fill="#6D7483"
    />
    <path
      d="M13.5 6.34039V4.00039H12.6V6.33175C12.3408 6.42701 12.117 6.59953 11.9589 6.82602C11.8009 7.0525 11.7161 7.32204 11.7161 7.59823C11.7161 7.87442 11.8009 8.14396 11.9589 8.37044C12.117 8.59693 12.3408 8.76945 12.6 8.86471V13.0004H13.5V8.86903C13.7592 8.77377 13.983 8.60125 14.1411 8.37476C14.2991 8.14828 14.3839 7.87874 14.3839 7.60255C14.3839 7.32636 14.2991 7.05682 14.1411 6.83034C13.983 6.60385 13.7592 6.43133 13.5 6.33607V6.34039Z"
      fill="#6D7483"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5999 0.400391C2.10873 0.400391 0.899902 1.60922 0.899902 3.10039V13.9004C0.899902 15.3916 2.10873 16.6004 3.5999 16.6004H14.3999C15.8911 16.6004 17.0999 15.3916 17.0999 13.9004V3.10039C17.0999 1.60922 15.8911 0.400391 14.3999 0.400391H3.5999ZM3.5999 2.20039C3.10285 2.20039 2.6999 2.60333 2.6999 3.10039V13.9004C2.6999 14.3974 3.10285 14.8004 3.5999 14.8004H14.3999C14.897 14.8004 15.2999 14.3974 15.2999 13.9004V3.10039C15.2999 2.60333 14.897 2.20039 14.3999 2.20039H3.5999Z"
      fill="#6D7483"
    />
  </svg>
);
